import { type ReferralBonusTypes } from "@src/appV2/Accounts/WorkerReferrals/types";
import { isActivationTypeReferral } from "@src/appV2/Accounts/WorkerReferrals/utils/isActivationTypeReferral";

import { type ReferralEligibility } from "../../api/useReferralsEligibilityV2";
import { type ReferralDetails } from "../../types";
import { BaseReferralStatusCard } from "./BaseReferralStatusCard";

interface CannotReceiveReferralsCardProps {
  outgoingReferralDetails: ReferralDetails;
  referralsEligibility: ReferralEligibility[];
}

export function CannotReceiveReferralsCard(props: CannotReceiveReferralsCardProps) {
  const { outgoingReferralDetails, referralsEligibility } = props;

  const { bonusAmount } = outgoingReferralDetails;

  const activationEligibility = referralsEligibility.find((eligibility) =>
    isActivationTypeReferral(eligibility.attributes.referralProgram as ReferralBonusTypes)
  );

  const ineligibilityReason = activationEligibility?.attributes.ineligibilityReason;
  const ineligibilityMessage = activationEligibility?.attributes.ineligibilityMessage;

  let title = "You can't receive referrals.";
  if (ineligibilityReason === "already_worked") {
    title = "You can't receive referrals because you've already worked your first shift.";
  } else if (ineligibilityReason === "already_paid_bonus") {
    title = "You can't receive referrals because you've already received a referral bonus.";
  }

  const description =
    bonusAmount > 0
      ? `But don't worry, you can still share your referral link with your friends to earn a $${bonusAmount} bonus.`
      : ineligibilityMessage;

  return <BaseReferralStatusCard title={title} description={description} illustration="unlock" />;
}
